import React, {useState, useEffect} from "react";
import AuthContainer from "../../containers/AuthContainer";
import {
   ContentAuth,
   CardAuth,
   TitleAuth,
   CardOptions,
   FormAuth,
   ContainerButtons,
   OrComponent,
   TextLink,
   TextAuth,
} from "./components/AuthStyles";
import {Content} from "../../styles/GlobalStyles";
import ButtonSocial from "./components/ButtonSocial";
import {ReactComponent as FacebookIcon} from "../../assets/icons/facebook.svg";
import {ReactComponent as GoogleIcon} from "../../assets/icons/google-plus.svg";
import GetDataComponent from "./components/GetDataComponent";
import {returnAge} from "../../constants/Helpers";
import AppLoader from "../../components/loaders/Loader";
import {RegisterService} from "../../services/UserServices";
import {privateEmail} from "./components/Helpers";
import styled from "styled-components";
import Color from "../../assets/Colors";
import {useLocation, useHistory} from "react-router-dom";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";

export default function RegisterView() {
   const [errorsList, setErrors] = useState([]); // {name: "", text: ""}
   const [isLoading, setLoading] = useState(false); // evitar muchos clicks
   const [success, setSuccess] = useState(false); // para mostrar el mensaje de success
   const [auth, setAuth] = useState({email: "", pwd: ""});
   const [registerType, setRegisterType] = useState("email");
   let history = useHistory();
   let location = useLocation();

   useEffect(() => {
      let prevType = location.state ? location.state.type : 3;
      setRegisterType(prevType);
   }, [location]);

   const doRegister = (e) => {
      e.preventDefault();
      setLoading(true);
      setErrors([]);
      let birthDay = returnAge(new Date(e.target.dateYear.value, e.target.dateMonth.value, e.target.dateDay.value));
      /// obtener los datos
      let toSave = {
         idRol: 2,
         idRegisterType: e.target.idRegisterType.value,
         userName: e.target.name.value,
         userLastName: e.target.userLastName.value,
         age: birthDay,
         idSex: e.target.idSex.value,
         email: e.target.email.value,
         pwd: e.target.pwd.value,
         pwdConfirm: e.target.pwdConfirm.value,
         idSecurityQuestion: e.target.idSecurityQuestion.value,
         securityAnswer: e.target.securityAnswer.value,
         idExpYears: 1,
         industryExperience: e.target.industryExperience.value,
         workplace: "",
      };

      // validar que contraseña coincida
      if (toSave.pwd !== toSave.pwdConfirm) {
         return setErrors([{name: "password", text: "La contraseña no coincide"}]);
      }

      RegisterService(toSave)
         .then((res) => res.json())
         .then((resp) => {
            const {status} = resp;
            console.log(resp);
            if (status === "error") {
               if (resp.message === "User already exists") {
                  setErrors([{name: "email", text: "El correo ya está registrado, inicia sesión o intenta con otro correo"}]);
                  if (status === "error") throw new Error();
               }
            }
            setAuth({...auth, email: toSave.email});
            setSuccess(true);
            setLoading(false);

            return true;
         })
         .then((status) => {
            if (status) window.scrollTo({top: 0, behavior: "smooth"});
         })
         .catch((e) => {
            console.log(e);
            setLoading(false);
         });
   };

   function fbLogin(resp) {
      // registro con  fb
      console.log(resp);
      const {first_name, email, last_name, userID} = resp;
      let dataLogin = {first_name, email, last_name, userID, pwd: userID};
      console.log(dataLogin);
      history.replace("/registro", {prevData: dataLogin, type: 2});
      // doLogin(dataLogin, true, "fb");
   }
   function gooLogin(resp) {
      // registro con google
      let {googleId, email, name, familyName} = resp.profileObj;
      let dataLogin = {first_name: name, email: email, last_name: familyName, userID: googleId, pwd: googleId};
      console.log(dataLogin);
      history.replace("/registro", {prevData: dataLogin, type: 1});
      // doLogin(dataLogin, true, "google");
   }

   return (
      <>
         <AuthContainer>
            <Content>
               <ContentAuth>
                  <CardAuth>
                     <CardOptions>
                        {success ? (
                           <CardOptions>
                              <CardOptions>
                                 <div className="head">
                                    <TitleAuth>
                                       Bienvenido a <br /> Domecq Acaddemy
                                    </TitleAuth>
                                 </div>
                                 <TextAuth>
                                    Hemos enviado un correo a {privateEmail(auth.email)} para confirmar tu dirección de correo electrónico
                                 </TextAuth>

                                 <BoldText>
                                    <p>
                                       El lugar de la experiencia, <br />
                                       pasión y conocimiento
                                    </p>
                                 </BoldText>
                              </CardOptions>
                           </CardOptions>
                        ) : (
                           <>
                              <div className="head">
                                 <TitleAuth>Crear cuenta</TitleAuth>
                              </div>

                              {registerType === 3 && (
                                 <>
                                    <ContainerButtons>
                                       <FacebookLogin
                                          appId="241705067022446"
                                          // autoLoad
                                          callback={fbLogin}
                                          fields="first_name,email,last_name"
                                          render={(renderProps) => (
                                             <ButtonSocial
                                                action={renderProps.onClick}
                                                Icon={FacebookIcon}
                                                title="iniciar sesión con facebook"
                                             />
                                          )}
                                       />
                                       <GoogleLogin
                                          clientId="950896258717-oo4nrjjlbpgn52q5lph1lmnjm526q0vo.apps.googleusercontent.com"
                                          render={(renderProps) => (
                                             <ButtonSocial
                                                action={() => renderProps.onClick()}
                                                Icon={GoogleIcon}
                                                title="iniciar sesión con google"
                                             />
                                          )}
                                          buttonText="Login"
                                          onSuccess={gooLogin}
                                          onFailure={gooLogin}
                                          cookiePolicy={"single_host_origin"}
                                       />
                                    </ContainerButtons>
                                    <OrComponent />
                                 </>
                              )}

                              <FormAuth onSubmit={doRegister}>
                                 <TextLink visibleborder="none" as="label">
                                    Registrate directamente en Domecq Academy
                                 </TextLink>  
                                 <GetDataComponent errorsList={errorsList} />
                              </FormAuth>
                           </>
                        )}
                     </CardOptions>
                  </CardAuth>
               </ContentAuth>
            </Content>
         </AuthContainer>
         <AppLoader isVisible={isLoading} />
      </>
   );
}

const BoldText = styled.div`
   width: 100%;
   margin-top: 3em;

   & p {
      color: ${Color.primary};
      font-size: 1.3em;
      font-weight: bold;
   }

   @media screen and (max-width: 1600px) {
      & p {
         font-size: 1em;
      }
   }
`;
